import ItemCustomerDTO, { IItemCustomer } from "./ItemCustomerDTO";
import ItemsDTO from "./ItemsDTO";

export class CustomersDTO extends ItemsDTO {

  public mapItems(items: IItemCustomer[]) {
      return items.map((i: IItemCustomer) => new ItemCustomerDTO(i))
    }
}
